import {ReactNode, useState} from "react";

import {DropdownAction, DropdownActionItem, DropdownItem} from "@/components/quickActionsBar/DropdownAction.tsx";
import {DropdownDivider} from "@/components/quickActionsBar/DropdownDivider.tsx";
import {QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {ContactGroup} from "@/lib/types/contacts.ts";
import {DeleteContactButtonAction} from "@/pages/contacts/list/actions/DeleteContactButtonAction.tsx";
import {EditContactModalAction} from "@/pages/contacts/list/actions/EditContactModalAction.tsx";
import {TestContactButtonAction} from "@/pages/contacts/list/actions/TestContactButtonAction.tsx";

export interface ContactQuickActionsBarProps {
  contact: ContactGroup;
  hasWriteAccess: boolean;
}

export const ContactQuickActionsBar = ({contact, hasWriteAccess}: ContactQuickActionsBarProps) => {
  const [showEdit, setShowEdit] = useState(false);
  const [showTest, setShowTest] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const actions: ReactNode[] = [];

  if (hasWriteAccess) {
    const dropdownItems: DropdownItem[] = [
      <DropdownActionItem text="Edit Contact" onClick={() => setShowEdit(true)} />,
      <DropdownActionItem text="Test Contact" onClick={() => setShowTest(true)} />,
      <DropdownDivider />,
      <DropdownActionItem text="Delete Contact" onClick={() => setShowDelete(true)} />,
    ];
    actions.push(<DropdownAction id={`contact-${contact.id}`} items={dropdownItems} />);
  }

  return (
    <>
      <QuickActionsBar id="contacts-page" actions={actions} />
      {hasWriteAccess && (
        <EditContactModalAction
          formId={`form-contact-${contact.id}`}
          contact={contact}
          show={showEdit}
          setShow={setShowEdit}
        />
      )}
      {hasWriteAccess && <TestContactButtonAction contact={contact} show={showTest} setShow={setShowTest} />}
      {hasWriteAccess && <DeleteContactButtonAction contact={contact} show={showDelete} setShow={setShowDelete} />}
    </>
  );
};
